import React from 'react'

import { FieldSchema } from '@/lib/builder/schemas'

import RichTextEditor from '@/components/ui/RichTextEditor'

interface RichTextFieldProps {
  field: FieldSchema
  value: string
  onChange: (value: string) => void
}

export const RichTextField = ({ field, value, onChange }: RichTextFieldProps) => {
  return (
    <div className="space-y-2">
      <RichTextEditor
        value={value || ''}
        onChange={onChange}
        placeholder={field.placeholder || 'Enter rich text content...'}
        className="min-h-[300px]"
      />
      <p className="text-sm text-ink">
        HTML Supported • Formatting Enabled
      </p>
    </div>
  )
}
